import { Card } from "@mantine/core";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Calendar, DateObject } from "react-multi-date-picker";

type Props = {
  setDate: (e: Date[]) => void;
  minDate?: boolean;
};

function SelectDate({ setDate, minDate }: Props) {
  const selectDate = (date: DateObject[]) => {
    setDate(date.map((d) => new Date(d.valueOf())));
  };

  return (
    <Card p="0">
      <Calendar
        className="custom-container"
        calendar={persian}
        locale={persian_fa}
        range
        weekPicker
        onChange={selectDate}
        minDate={minDate ? new Date() : undefined}
      />
    </Card>
  );
}

export default SelectDate;
